import { Reveal, MaskLine, FadeIn } from "../components/Reveal";
import ClosingBlock from "../components/ClosingBlock";

const STAGES = [
  {
    n: "01",
    title: "Formulation",
    body: "Every formula is written by Dr. Shibina herself, and adjusted over years of patient feedback. Nothing is bought off a manufacturer's catalogue.",
  },
  {
    n: "02",
    title: "Sourcing",
    body: "Ingredients are selected and checked before they enter the facility. If a lot of herbs is not good enough for the clinic's patients, it does not go into a jar.",
  },
  {
    n: "03",
    title: "Preparation",
    body: "Made in small batches under our own licence. The Kaachenna hair oil is still prepared the traditional slow way, with the herbs cooked into the oil.",
  },
  {
    n: "04",
    title: "Filling & labelling",
    body: "Every jar and bottle is filled, sealed and labelled with its batch number, date of manufacture and best-before. By hand, because the batches allow it.",
  },
  {
    n: "05",
    title: "Batch record",
    body: "Every batch is recorded and traceable. If you ever write to us about a jar, we can tell you exactly when it was made and from what.",
  },
];

const HowWeMakeItPage = () => (
  <div className="pt-36 md:pt-44" data-testid="how-page">
    <header className="mx-auto max-w-7xl px-4 md:px-8">
      <FadeIn>
        <div className="flex items-center gap-4">
          <span className="h-px w-12 bg-ink/30" />
          <p className="eyebrow">How we make it</p>
        </div>
      </FadeIn>
      <h1 className="mt-8 font-serif font-light leading-[1.05] text-[10vw] sm:text-6xl lg:text-7xl">
        <MaskLine delay={0.15}>Our own licence.</MaskLine>
        <MaskLine delay={0.28}>Our own facility.</MaskLine>
        <MaskLine delay={0.41}>
          <span className="italic text-sage-deep">Small batches.</span>
        </MaskLine>
      </h1>
      <FadeIn delay={0.6} className="mt-8 max-w-xl">
        <p className="text-base leading-relaxed text-ink/70 md:text-lg">
          Most Ayurvedic personal-care brands are made by contract manufacturers — the same few
          factories producing for dozens of labels. Ayushi is made under our own cosmetic
          manufacturing licence, in our own facility in Thiruvananthapuram, in batches small
          enough for Dr. Shibina to check each one.
        </p>
      </FadeIn>
    </header>

    <section className="mx-auto max-w-7xl px-4 py-16 md:px-8 md:py-24">
      <div>
        {STAGES.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.05}>
            <div className="grid gap-4 border-t hairline py-10 md:grid-cols-12" data-testid={`stage-${s.n}`}>
              <p className="font-serif text-5xl font-light text-sage/70 md:col-span-2">{s.n}</p>
              <h3 className="font-serif text-2xl italic md:col-span-4">{s.title}</h3>
              <p className="max-w-xl text-[15px] leading-relaxed text-ink/70 md:col-span-6">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-10 border hairline bg-white/60 p-8 md:p-10" data-testid="licence-block">
          <p className="eyebrow">The licence</p>
          <p className="mt-4 max-w-2xl font-serif text-2xl font-light leading-relaxed md:text-3xl">
            Cosmetic Manufacturing Licence No. —{" "}
            <span className="italic text-sage-deep">to be inserted before launch.</span>
          </p>
          <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-ink/65">
            Publishing the number costs nothing, and most competitors cannot copy it, because they
            do not have one. It will appear here, in the footer, and on every product page.
          </p>
        </div>
      </Reveal>
    </section>

    <ClosingBlock />
  </div>
);

export default HowWeMakeItPage;
